var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_448_1373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9871 0.871094C23.9761 0.784912 23.957 0.701904 23.9255 0.624023C23.9246 0.62207 23.9246 0.619385 23.9241 0.616943C23.9241 0.616455 23.9236 0.615967 23.9231 0.615479C23.8884 0.533447 23.8411 0.458984 23.7876 0.389893C23.7744 0.373535 23.7615 0.357422 23.7476 0.342041C23.6904 0.277588 23.6284 0.218018 23.5564 0.169434C23.5544 0.167969 23.552 0.16748 23.55 0.166016C23.4805 0.120117 23.4036 0.0854492 23.323 0.0581055C23.303 0.0510254 23.2834 0.0449219 23.2629 0.0395508C23.1785 0.0166016 23.0916 0 23 0H16C15.448 0 15 0.447998 15 1C15 1.552 15.448 2 16 2H20.5854L14.6169 7.96851C13.0254 6.69556 11.0659 6 9 6C4.0376 6 0 10.0376 0 15C0 19.9624 4.0376 24 9 24C13.9624 24 18 19.9624 18 15C18 12.9351 17.3049 10.9761 16.031 9.38306L22 3.41406V8C22 8.552 22.448 9 23 9C23.552 9 24 8.552 24 8V1C24 0.979004 23.9951 0.958984 23.9939 0.938477C23.9924 0.915527 23.99 0.893555 23.9871 0.871094ZM9 22C5.13989 22 2 18.8601 2 15C2 11.1399 5.13989 8 9 8C10.8689 8 12.6284 8.72754 13.9514 10.0459C15.2725 11.3716 16 13.1311 16 15C16 18.8601 12.8601 22 9 22Z",
    fill: "#52DE97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_448_1373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.bf77b1723674c9a96b483b1d7a8859a0.svg";
export { ForwardRef as ReactComponent };